
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M15 2l2.793 2.793-6 6 1.414 1.414 6-6L22 9V2h-7zm5 18H4V4h8V2H3.111C2.497 2 2 2.498 2 3.111v17.778C2 21.502 2.497 22 3.111 22h17.778c.614 0 1.111-.498 1.111-1.111V12h-2v8z","id":"path-1"}})]),_c('g',{attrs:{"id":"icon-/-action-and-navigation-/-export-","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"mask-2","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_c('use',{attrs:{"id":"Export-icon","fill":"#3C3C41","xlink:href":"#path-1"}})])])
          )
        }
      }
    